import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../data/auth/token";
import { ReactNode } from "react";

function RequireAuth({ children, membership }: { children: ReactNode; membership?: boolean }) {
  let auth = useAuth();
  let location = useLocation();

  if (!auth.user) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    if (membership) {
      return <Navigate to="/membership?name=Hej" state={{ from: location }} replace />;
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default RequireAuth;
